import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "./slices/api-slice";
import authReducer from "./slices/auth/auth-slice";

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
  devTools: true,
});
export type RootState = ReturnType<typeof store.getState>;
export default store;
